jQuery(document).ready(function() {
  jQuery('.slide-galeria, .slide-galeria-plantas, .slide-galeria-obras').slick({
    fade: true
  });

  var firstPhoto = '.box-servico-select > figure:nth-child(1)';
  var firstList = '.selector-servico li:nth-child(1)';
  var allPhotos = '.box-servico-select > figure';

  jQuery(allPhotos).hide();
  jQuery(firstPhoto).show();
  jQuery(firstList).addClass('active').on('click', function() {
    jQuery('.selector-servico li').removeClass('active')
    jQuery(this).toggleClass('active');
    jQuery(allPhotos).hide()
    jQuery(firstPhoto).show()
  });
  jQuery('.selector-servico li:nth-child(2)').on('click', function() {
    jQuery('.selector-servico li').removeClass('active')
    jQuery(this).toggleClass('active');
    jQuery(allPhotos).hide()
    jQuery('.box-servico-select > figure:nth-child(2)').show()
  });
  jQuery('.selector-servico li:nth-child(3)').on('click', function() {
    jQuery('.selector-servico li').removeClass('active')
    jQuery(this).toggleClass('active');
    jQuery(allPhotos).hide()
    jQuery('.box-servico-select > figure:nth-child(3)').show()
  });

  jQuery('a.btn-play').on('click', function() {
    var iframe = '.fancybox-iframe';

    setTimeout(function() {
      console.log('play!');
      jQuery('.fancybox-iframe').contents().find('video')[0].play();
    }, 2000);

    console.log('iframe aberto');
  });

  jQuery('[data-fancybox3]').fancybox({
	youtube : {
		controls : 0,
		showinfo : 0
	},
	vimeo : {
		color : 'f00'
	}
});
});

var markersPiscine = [];
function marcadoresPiscine() {
    markersPiscine = [
      ['0', "Galeria 90", -23.600658, -46.674727, "main", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin.png"],
      ['0', "Universidade Anhembi Morumbi", -23.6000963, -46.6791652, "anhembiMorumbi", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "Shopping Vila Olímpia", -23.5953941, -46.6888667, "shopVilaOlimpia", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "Eataly", -23.591472, -46.6856342, "eataly", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "Hospital São Luiz", -23.6436783, -46.6448392, "saoLuiz", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "Parque do Povo", -23.5879931, -46.6909377, "pqPovo", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "Parque Ibirapuera", -23.587480, -46.659832, "pqIbira", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "Aeroporto de Congonhas", -23.6273197, -46.6587729, "congonhas", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "R. Casa do Ator", -23.598419, -46.679881, "rCasaAtor", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "Av. Santo Amaro", -23.593732, -46.672850, "avSantoAmaro", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "R. Gomes de Carvalho", -23.598147, -46.682925, "rGomesCarvalho", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "Av. dos Bandeirantes", -23.608981, -46.676227, "avBandeirantes", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "Av. Hélio Pellegrino", -23.598250, -46.672713, "avHelioPellegrino", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "Av. Juscelino Kubitschek", -23.590189, -46.680590, "avJuscelino", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"],
      ['0', "Marginal Pinheiros", -23.597992, -46.693364, "marginalPinheiros", "São Paulo", "zona", "Rua, Número - Bairro - Cidade/ESTADO", "CEP", "(DDD) 99999-9999", "assets/img/pin-alt.png"]
    ];
}

jQuery(document).ready(function() {


	// #################################################################
	// #################################################################
	// #################################################################
	// ############                                         ############
	// ############              Localização                ############
	// ############                                         ############
	// #################################################################
	// #################################################################
	// #################################################################

	if (jQuery('#localizacao').length > 0) {

		var gmarkersPiscine = [];
		var infowindowPiscine = new google.maps.InfoWindow({
			content: ''
		});

		marcadoresPiscine();


		/**
		 * Function to init map
		 */

		function initializePiscine() {
			var center = new google.maps.LatLng(-23.516604, -46.786747);
			var mapOptions = {
				zoom: 19,
				// center: center,
				scrollwheel: false,
				maxZoom: 19,
				mapTypeControl: false,
        styles: [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#212121"
              }
            ]
          },
          {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#212121"
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "administrative.country",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#bdbdbd"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#181818"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#1b1b1b"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#2c2c2c"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#8a8a8a"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#373737"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#6e363e"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#3c3c3c"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#6e363e"
              }
            ]
          },
          {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#4e4e4e"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#000000"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#3d3d3d"
              }
            ]
          }
        ]
			};

			mapPiscine = new google.maps.Map(document.getElementById('mapa1'), mapOptions);
			for (i = 0; i < markersPiscine.length; i++) {
				addMarkerPiscine(markersPiscine[i]);
			}


		}

		/**
		 * Function to add marker to map
		 */


		function addMarkerPiscine(marker) {
			var category = marker[4];
			var title = marker[1];
			var pos = new google.maps.LatLng(marker[2], marker[3]);
			var content = marker[1];
			var subcategory = marker[6];
			var icon = marker[10]

			markerPiscine = new google.maps.Marker({
				title: title,
				position: pos,
				category: category,
				map: mapPiscine,
				subcategory: subcategory,
				icon: icon,
			});

			gmarkersPiscine.push(markerPiscine);

			// Marker click listener
			google.maps.event.addListener(markerPiscine, 'click', (function (markerPiscine, content) {
				return function () {
					console.log('Gmarker 1 gets pushed');
					infowindowPiscine.setContent(content);
					infowindowPiscine.open(mapPiscine, markerPiscine);
					mapPiscine.panTo(this.getPosition());
					// mapPiscine.setZoom(15);
				}
			})(markerPiscine, content));
		}

		/**
		 * Function to filter markers by category
		 */

		function fitBoundsToVisibleMarkersPiscine() {

		    var bounds = new google.maps.LatLngBounds();

		    for (var i=0; i<gmarkersPiscine.length; i++) {
		        if(gmarkersPiscine[i].getVisible()) {
		            bounds.extend( gmarkersPiscine[i].getPosition() );
		        }
		    }

		    mapPiscine.fitBounds(bounds);

		}

		filterMarkersPiscine = function (category) {
			for (i = 0; i < markersPiscine.length; i++) {
				marker = gmarkersPiscine[i];
				// If is same category or category not picked
				if (marker.category == category || category.length === 0) {
					marker.setVisible(true);
				} else if (marker.category == "main") {
					marker.setVisible(true);
				} else { // Categories don't match
					marker.setVisible(false);
				}

				fitBoundsToVisibleMarkersPiscine()
			}

			// if (category == "") {

			// 	jQuery('section#localizacao div.enderecos p').show();

			// } else {

			// 	jQuery('section#localizacao div.enderecos p').each(function(index, el) {
			// 		if ( jQuery(this).hasClass(category) ) {
			// 			jQuery(this).show();
			// 		} else {
			// 			jQuery(this).hide();
			// 		};
			// 	});

			// };

		}

		// Init map

		initializePiscine();
		fitBoundsToVisibleMarkersPiscine();


		// ###############################################################
		// ###############################################################
		// ###############################################################
		// ###############################################################
		// ###############################################################
		// ###############################################################
		// ###############################################################
		// ###############################################################
		// ###############################################################
		// ###############################################################

		jQuery('section#localizacao div.filtros').on('click', 'a:not(.segredos)', function(event) {
			event.preventDefault();
			jQuery(this).parent().find('a').removeClass('active');
			filterMarkersPiscine(jQuery(this).attr('data-filter'));
			jQuery(this).addClass('active')
		});

		jQuery('section#localizacao div.filtros a.filtro').first().click();

	}

});
